import { mapGetters } from 'vuex';

export default {
    name: 'dapInfo',
    inject: ['$eventBus'],
    computed:{
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dap', ['dap']),
        isMovotoAgent(){
            return this.dap.agentType === 1;
        },
        agentImage() {
            return (this.dap.imageUrl || this.dap.agentImage) || this.glb.cdnUrl + 'images/desktop/agent/agent-min.png';
        }
    },
    data(){
        return {
            showMore: false
        };
    },
    methods: {
        toggle(){
            const $desc = $(this.$el).find('.dap-info-desc');
            this.showMore = !this.showMore;
            if(this.showMore){
                $desc.addClass('all');
            }else{
                $desc.removeClass('all');
            }
        },
        checkDescription: function(){
            const $desc = $(this.$el).find('.dap-info-desc');
            if($desc.length > 0){
                if($desc.prop('scrollHeight') > $desc.prop('clientHeight')){
                    $desc.addClass('limit');
                }else{
                    $desc.removeClass('limit');
                }
            }
        },
        openBankrate: function(){
            const extraPath = window.location.href.includes('/agents/') && window.location.href.split('/agents/')[1];
            window.open('https://pro.bankrate.com/pilot/' + extraPath, '_blank');
        }
    },
    mounted(){
        $(document).on('dom.resize', this.checkDescription);
        this.checkDescription();
    }
};